<template>
  <div>
    <v-container v-if="onboardings && onboardings.length > 0">
      <v-row>
        <v-col cols="12">
          <v-carousel v-if="applicationName" cycle interval="2000" height="390">
            <v-carousel-item
              v-for="(onboarding, i) in onboardings"
              :key="i"
              :src="onboarding.imageUrl"
              :lazy-src="onboarding.imageUrl"
            >
              <v-btn class="text-caption">
                {{
                  translatedConfig(
                    generalExApplicationEx,
                    customLanguage,
                    onboarding,
                    "text"
                  )
                }}
              </v-btn>
            </v-carousel-item>
          </v-carousel>
        </v-col>
      </v-row>
    </v-container>

    <br />
    <br />

    <v-sheet
      v-if="menuItems && menuItems.length > 0"
      class="mx-auto"
      elevation="8"
      max-width="1050"
    >
      <v-slide-group v-model="selItem" class="pa-4" center-active show-arrows>
        <v-slide-item
          v-for="menuItem in menuItems"
          :key="menuItem.id"
          v-slot="{ active }"
        >
          <v-card
            :color="active ? 'primary' : 'transparent'"
            class="mx-auto"
            height="230"
            width="180"
            elevation="0"
            outlined
            @click="menuItem.action"
          >
            <v-container>
              <v-img
                v-if="menuItem.image"
                :src="menuItem.image"
                max-height="140"
                max-width="150"
              >
              </v-img>
              <v-icon v-else size="150">
                {{ menuItem.icon }}
              </v-icon>
              <br />
              <v-card flat class="text-center">
                {{
                  translatedConfig(
                    generalExApplicationEx,
                    customLanguage,
                    menuItem,
                    "caption"
                  )
                }}
              </v-card>
            </v-container>
          </v-card>
        </v-slide-item>
      </v-slide-group>
    </v-sheet>
  </div>
</template>

<script>
export default {
  name: "Onboarding",
  props: [
    "session",
    "environment",
    "applicationName",
    "generalExApplicationEx",
    "customLanguage",
  ],
  data() {
    return {
      onboardings: [],
      onboardingsLoaded: false,
      menuEx: {},
      menuItems: [],
      selItem: null,
      menusLoaded: false
    };
  },
  methods: {
    loadAll(applicationName, session) {
      this.loadOnboardings(applicationName);
      this.loadMenus(applicationName, session);
    },
    loadOnboardings(applicationName) {
      if (applicationName) {
        this.onboardings = [];
        this.onboardingsLoaded = false;
        this.loading = true;
        this.apiLoadOnboardings({ path: { applicationName } })
          .then((onboardingsRes) => {
            this.onboardings = onboardingsRes.data;
            this.onboardingsLoaded = true;
          })
          .catch((onboardingsErr) => {
            console.log(onboardingsErr);
          });
      }
    },

    loadMenus(applicationName, session) {
      if (applicationName && session) {
        /* const session = this.appContextLoadSession({
          applicationName: this.applicationName,
          generalExApplicationEx: this.generalExApplicationEx,
        }); */
        this.apiLoadMenus({
          path: { applicationName },
          body: session?.details?.roles
            ? Array.isArray(session?.details?.roles)
              ? session?.details?.roles
              : session?.details?.roles.split(",")
            : [],
        })
          .then((menuRes) => {
            this.menuEx = menuRes.data;
            this.parseMenuItems();
          })
          .catch((menuErr) => {
            console.log(menuErr);
          });
      }
    },

    parseMenuItems() {
      this.menuItems = this.menuEx.menus
        .map((menu, index) => {
          let endMenu = menu;
          menu.action = () => {
            this.clickMenuItem(index);
          };
          return endMenu;
        })
        .filter((menu) => {
          return menu.behavior === "ONBOARDING";
        });
      this.menusLoaded = true;
    },

    clickMenuItem(index) {
      let data = this.menuEx.menus[index];
      if (data.transactionName !== "") {
        this.$emit("sel-menu", data);
      }
    },
  },
  created() {
    this.loadAll(this.applicationName, this.session);
  },

  mounted() {
    this.loadAll(this.applicationName, this.session);
  },
};
</script>

<style>
</style>